<div class="container-fluid header-banner-wrapper access-forms">
  <app-header-b></app-header-b>
  <div class="container px-0">
  <div class="row">
    <div class="col-md-5 p-0 form-character-wrapper">
      <h4 class="text-center fWeight-600 fColor-white mt-4"><span class="helloTapTapTeamSpan">Hello from the TapTap Team!</span> Did you forgot your password? Please send an email request</h4>
      <img src="./assets/img/registration/woman-high-5-violet.png" alt="Sign Up Image" class="signup-img">
    </div>
    <div class="col-md-7 box-wrapper">
      <div class="primary-box">
        <div class="box-top">
            <p *ngIf="success" class="alert alert-success">
                We've sent you an email together with the reset password link
            </p>

          <p *ngIf="!isValid" class="alert alert-danger">
              The given data was invalid
          </p>
          <p *ngIf="email.invalid && email.errors['required'] && submitIsClicked" class="alert alert-danger">
              Email is required
          </p>
          <p *ngIf="taptapRecaptcha.invalid && submitIsClicked" class="alert alert-danger">
              Please verify you're a human
          </p>
          <h4 class="fColor-base fWeight-600">Forgot your Password?</h4>
          <form [formGroup]="forgotPasswordForm">
              <div class="form-group">
                  <label for="email">Email<sup>*</sup></label>
                  <input type="email" class="form-control" name="email" id="email" formControlName="email" required />
              </div>
              <div class="d-flex justify-content-around align-items-center flex-wrap mb-3">
                  <recaptcha
                      [formControl]="taptapRecaptcha"
                      (scriptLoad)="onScriptLoad()"
                      (scriptError)="onScriptError()"
                      class="recaptcha-wrapper my-2"
                  ></recaptcha>
                  <button type="submit" class="btn btn-first"  (click)="proceed()">Send Request Now<!--<i class="fas fa-angle-double-right ml-2"></i>--></button>
              </div>
          </form>
      </div>
        <div class="box-bottom d-flex justify-content-between align-items-center">
            <!-- <a routerLink="/registration" class="capitalize"><h6 class="fWeight-600">Already have an account? Register Here</h6></a> -->
            <a (click)="goBackToLastPage()" class="capitalize"><h6 class="fWeight-600">Go Back</h6></a>            
        </div>
      </div>
    </div>
  </div>
</div>
</div>
